import React from 'react'

import PropTypes from 'prop-types'

import { ConfirmationDialog } from 'components'

const ColumnDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  loading,
  accentColor,
}) => (
  <ConfirmationDialog
    open={open}
    setOpen={onClose}
    text="Tem certeza que deseja excluir esta coluna? Esta ação não pode ser desfeita."
    textButton="Excluir"
    textButtonCancel="Cancelar"
    loading={loading}
    actionAcceptButton={onConfirm}
    accentColor={accentColor}
  />
)

ColumnDeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  accentColor: PropTypes.string,
}

export default ColumnDeleteDialog
